function handleGtmEvent(gtmEventName) {
    if (typeof window === 'undefined')
        return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: gtmEventName,
    });
}
export { handleGtmEvent };
